import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../common/store/generic.effects';
import { SourceApiService } from './source.api.service';
import { SourceAction, sourceActions } from './source.action';

@Injectable()
export class SourceEffects {
  constructor(
    private readonly sourceApiService: SourceApiService,
    private readonly action$: Actions<SourceAction>,
  ) {}

  getById = createApiCallEffects(
    this,
    this.action$,
    sourceActions.getById,
    this.sourceApiService.getById,
  );

  getList = createApiCallEffects(
    this,
    this.action$,
    sourceActions.getList,
    this.sourceApiService.getList,
  );

  postSource = createApiCallEffects(
    this,
    this.action$,
    sourceActions.add,
    this.sourceApiService.add,
  );

  updateSource = createApiCallEffects(
    this,
    this.action$,
    sourceActions.update,
    this.sourceApiService.update,
  );
}
